import React, { useRef } from "react";
import { 
	RCCButton, 
	RCCGrid, 
	RCCTooltip,  
	RCCDropDownItem, 
	RCCIcon,
	RCCBadge
} from "react-common-components";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import { useTranslation } from "src/context/Translations/context";
import Pagination from "src/components/Pagination";
import PageTitle from "src/components/PageTitle";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import AppIcons from "src/components/AppIcons";
import ModalsDomains from "./modals";
import { IRefDomainsModals } from "./interface";

const Domains: React.FC = () => { 
	const { translate } = useTranslation();
	
	const refModalsDomains = useRef<IRefDomainsModals>(null);

	// List & Pagination
	const paginationRef = useRef<IForwardPagination>(null);
	const colOptions = (row: any) => (
		<OptionsColumn>
			<RCCDropDownItem
				selfEnclose
				onClick={() => { refModalsDomains.current?.actionButtonChange(row); }}
			>
				<RCCIcon name="pencil" 
				/>
				{translate("Alterar")}
			</RCCDropDownItem>
			<RCCDropDownItem 
				selfEnclose
				onClick={() => { refModalsDomains.current?.actionButtonDelete(row); }}
			>
				<RCCIcon name="trash" 
				/>
				{translate("Excluir")}
			</RCCDropDownItem>
		</OptionsColumn>
	);

	const colType = (row: any) => (
		<>
			{row.efa027Tipo === 1 && (
				<>
					<RCCIcon
						name="microsoft"
						color="var(--default-color-font)"
						style={{ marginRight: "4px" }}
					/>
					Microsoft
				</>
			)}
		</>
	);

	const colSituation = (row: any) => (
		<RCCBadge color={row.efa027Ativo === "S" ? "green" : "red"}>
			{row.efa027Ativo === "S" ? translate("Ativo") : translate("Inativo")}
		</RCCBadge>
	);

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
			>
				{/* Header -> Results + Buttons */}
				<PageTitle
					title={translate("Domínios")}
					icon={() => <AppIcons name="configs" />}
				>
					<RCCTooltip
						text={translate("Novo domínio")}
						color="purple"
					>
						<RCCButton
							icon={{name: "plus", color: "#FFF", size: 18}}
							color="purple"
							layout="isRounded"
							onClick={() => { refModalsDomains.current?.actionButtonAdd(); }}
							size="md"
						/>
					</RCCTooltip>
				</PageTitle>

				{/* List */}
				<Pagination 
					ref={paginationRef}
					dataOrRoute="Domains/List"
					columns={[
	  					{
							idColumn: "efa027Dominio",
							nameColumn: translate("Domínio"),
							xs: 12,
							sm: 6
	  					},
						{
							idColumn: "efa027Tipo",
							nameColumn: translate("Tipo"),
							xs: 12,
							sm: 2,
							cellRenderer: colType
	  					},
						{
							idColumn: "efa027Ativo",
							nameColumn: translate("Situação"),
							xs: 12,
							sm: 2,
							cellRenderer: colSituation
	  					},
						{
							idColumn: "options",
							nameColumn: " ",
							justify: "right",
							xs: 12,
							sm: 2,
							cellRenderer: colOptions,
							disableSort: true
						}
					]}
				/>
			</RCCGrid>

			<ModalsDomains 
				ref={refModalsDomains}
				paginationRef={paginationRef}
			/>
		</>
	);
};

export default Domains;
